import { Checkbox as Root } from '@forgeglobal/design-framework';
import cs from 'classnames';
import { FC } from 'react';
import { FieldRenderProps } from 'react-final-form';
import { useStyles } from './style';

const Checkbox: FC<FieldRenderProps<any>> = ({
  input: { checked, name, onChange, ...restInput },
  meta,
  ...rest
}) => {
  const classes = useStyles();
  return (
    <Root
      {...rest}
      name={name}
      inputProps={restInput}
      onChange={onChange}
      checked={checked}
      className={cs({
        [classes.error]: meta.error && meta.touched,
      })}
    />
  );
};

export default Checkbox;
